import React from "react";
import { Container } from "./page-container.styles";

export default function PageContainer(props) {
  return <Container>{props.children}</Container>;
}
